@import url(../../global/global.css);
:host {
  display: inline;
}

.dc-display-card-group {
  display: grid;
  row-gap: 24px;
}

@media (--breakpoint-desktop) {
  .dc-display-card-group {
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    row-gap: 32px;
  }
}
